/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  READ_RECONCILIATION,
  RECONCILIATION_PATH,
} from 'domain/finance/costAccounting/reconcilation/useReconciliationService';
import ReconcilationList from 'domain/finance/costAccounting/reconcilation/List';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';

const useReconcilationRoute = () => {
  return createRoute({ listRoute: RECONCILIATION_PATH });
};

const ReconciliationRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useReconcilationRoute();

  return (
    <ProtectedRouter basePath={RECONCILIATION_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_RECONCILIATION}>
              <ReconcilationList />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ReconciliationRouter.getRouterPath = () => `${RECONCILIATION_PATH}/*`;

export default ReconciliationRouter;
